import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Amplitude from '../../utils/amplitudeHelper'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import day1 from '../../images/event/day1.jpg'
import day2 from '../../images/event/day2.jpg'
import day3 from '../../images/event/day3.jpg'
import programme from '../../images/event/programme-overview.jpg'
import Axios from 'axios'
import { toast } from 'react-toastify'
import config from '../../config'
import { COLORS } from '../../styles/theme'
import ProgrammeListing from '../../components/ProgrammeListing'
import { Row, Col } from 'react-bootstrap'

const MobileMenu = ({ currentUser }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [tab, setTab] = useState('agenda')
  const [ agenda, setAgenda ] = useState(0)
  const [loading, setLoading] = useState(true)
  const [members, setMembers] = useState([])
  const [lectureHall, setLectureHall] = useState(1)

  useEffect(() => {
    Axios
      .get(`${config.apiUrl}/api/faculty_members`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success){
          setMembers(data.members)
          setLoading(false)
        }
      })
      .catch((err) => {
        setLoading(false)
        toast("Something went wrong. Please refresh your browser.")
        console.error('Error: ', err)
      })
  }, [])

  const goBack = () => {
    history.goBack()
  }

  return (
    <Page>
      <div className="outer-wrapper">
        <div className="container">
          <div className="title-container">
            <p className="title"></p>
            <div className="back-button" onClick={goBack}>
              Back
            </div>
          </div>

          <div className="tab-container">
            <p onClick={() => setTab('agenda')} className={tab === 'agenda' ? 'active' : ''}>
              Agenda
            </p>
            <p onClick={() => setTab('speakers')} className={tab === 'speakers' ? 'active' : ''}>
              Speakers
            </p>
          </div>
        </div>


        {tab === 'agenda' && (
          <div id="mobile-agenda">
            <div className="agenda">
            <button className={`${agenda === 0 && 'active'}`} onClick={()=>setAgenda(0)}>Overview</button>
            <button className={`${agenda === 1 && 'active'}`} onClick={()=>setAgenda(1)}>Day 1</button>
            <button className={`${agenda === 2 && 'active'}`} onClick={()=>setAgenda(2)}>Day 2</button>
            <button className={`${agenda === 3 && 'active'}`} onClick={()=>setAgenda(3)}>Day 3</button>
            <LazyLoadImage effect="black-and-white" src={[programme, day1, day2, day3][agenda]} width="100%" alt="agenda" />
            </div>
          </div>
        )}

        {tab === 'speakers' && (
          <div>
            <Row noGutters className="my-3 align-items-start">
              {members && members.map(speaker=>(
                <Col sm={3} key={`menu-${speaker.id}`}>
                  <div className="image mb-2 mx-auto img-fluid rounded-circle" style={{backgroundImage: `url(${speaker.image.url})`}}></div>
                  <h5 className="speaker-name">{speaker.honorific}</h5>
                  <h5 className="speaker-name">{speaker.fullName}</h5>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: white;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 90%;
    margin: auto;
  }

  .title-container {
    margin: 20px 0px 10px 0px;
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  #mobile-agenda {
    .agenda {
      margin-top: 12px;
      text-align: center;
      button {
        margin: 0 16px;
        background: #F87949;
        border: 2px solid #FF9821;
        font-weight: 500;
        border-radius: 12px;
        padding: 2px 12px;
        color: white;
        font-size: 12px;
      }
      .active {
        font-style: italic;
        color: #3f51b5;
        font-weight: 600;
      }
    }
    header {
      text-align: center;
    }
  }

  .title {
    width: 70%;
    font-size: 22px;
    font-weight: bold;
    font-style: italic;
    color: black;
    margin: 0;
  }

  .back-button {
    font-size: 12px;
    color: #312384;
    font-weight: bold;
  }
  .speaker-title {
    font-size: 24px;
    color: #426fa8;
    font-weight: bold;
    text-align: center;
  }
  .image {
    height: 184px;
    width: 184px;
    transition: 100ms linear;
    background-position: center;
    background-size: cover;
  }
  h5.speaker-name {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #0c6bae;
  }
  .divider {
    background: #FFAD2C;
    height: 2px;
    margin: 16px auto;
    width: 80%;
  }
  .profile-container {
    width: 100%;
    height: 100px;
    margin: 10px 0px;
    display: flex;
    align-items: center;
  }


  .profile-info-container {
    width: calc(100% - 90px);
    height: 55px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .profile-info-name {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0px;
  }

  .profile-info-edit {
    margin-bottom: 0px;
    width: 100%;
  }

  .profile-info-edit-text {
    font-size: 12px;
    color: black;
    margin-right: 10px;
  }

  .tab-container {
    padding: 5px 0px 20px 0px;
    width: 95%;
    border-bottom: solid 2px #e2cfff;
    margin: auto;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: bold;
    font-style: italic;

    p {
      margin-bottom: 0;
    }

    .active {
      color: #e50000;
    }
  }

  .about-container {
    font-size: 12px;
    text-align: center;
    margin-top: 20px;
  }

  .speaker-day {
    font-size: 14px;
    font-weight: bold;
    font-style: italic;
    margin: 20px 0px;
  }

  .speaker-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .speaker-item-wrapper {
    width: 33.33%;
    display: flex;
    justify-content: center;
  }

  .speaker-item-container {
    width: 70px;
    height: 95px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .speaker-item-image {
    width: 70px;
    height: 70px;
    border-radius: 10px;
    border: solid 2px #662283;
    background: #ede1fe;
  }

  .speaker-item-name {
    font-size: 12px;
    text-align: center;
    margin-bottom: 0;
  }

  .item-image {
    margin-top: 10px;
    width: 100%;
  }

  .avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileMenu
